class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
      document.querySelector('body').classList.remove('open-filter','open-sort');
      typeof infinitescroll == 'object' && typeof infinitescroll?.scolljs == 'function' && infinitescroll?.scolljs()
    }, 500);
    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }
  static setListeners() {
      const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }
  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
      FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }
  static renderSectionFromFetch(url, event) {
    fetch(url)
    .then(response => response.text())
    .then((responseText) => {
      const html = responseText;
      FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      //FacetFiltersForm.renderActiveFilter(html);
      typeof infinitescroll == 'object' && typeof infinitescroll?.scolljs == 'function' && infinitescroll?.scolljs()
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
    });
    }
      static renderSectionFromCache(filterDataUrl, event) {
      const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      //FacetFiltersForm.renderActiveFilter(html);
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
    }
      static renderProductGridContainer(html) {
      document.getElementById('collection-grid').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('collection-grid').innerHTML;
    }
      static renderFilters(html, event) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const facetDetailsElements =
        parsedHTML.querySelectorAll('.filter-index');
      const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.filter-index') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
          const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    facetsToRender.forEach((element) => {
      document.querySelector(`.filter-index[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });
  }
  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }
  static getSections() {
    return [
      {
        section: document.getElementById('collection-grid').dataset.id,
      }
    ]
  }
  // onSubmitHandler(event) {    
  //   event.preventDefault();
  //   const formData = new FormData(event.target.closest('form'));
  //   const searchParams = new URLSearchParams(formData).toString();
  //   FacetFiltersForm.renderPage(searchParams, event);    
  // }
  onSubmitHandler(event) {  
     const  filterCheck=(params)=> {
      return params.match(/filter/g).length
   }
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    let searchParams = new URLSearchParams(formData).toString();
    const result = filterCheck(searchParams);
    if(!(searchParams.includes("availability"))){
      searchParams = searchParams + "&filter.v.availability=1";
      // console.log("it doesnt includes", result);
      console.log("doesn't include",searchParams, result);
    }else if(result <= 3 && searchParams.includes("availability")){
      searchParams = searchParams.replace('&filter.v.availability=1', " ");
      console.log(searchParams);
      console.log("less than 3 & does include", result) 
    }
    FacetFiltersForm.renderPage(searchParams, event); 
    $('.sorted_val').text($('.filter-sort input[type="radio"]:checked').data('name'));
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
function rangePrice(params) {
  var lowerSlider = document.querySelector('#lower'),
   upperSlider = document.querySelector('#upper'),
   lowerVal = parseInt(lowerSlider.value);
   upperVal = parseInt(upperSlider.value);
  upperSlider.oninput = function() {
    lowerVal = parseInt(lowerSlider.value);
    upperVal = parseInt(upperSlider.value);    
    $('.nextsetval').val(upperVal);
    $('.prevtsetval').val(lowerVal);
    if (upperVal < lowerVal + 4) {
      lowerSlider.value = upperVal - 4;
      if (lowerVal == lowerSlider.min) {
         upperSlider.value = 4;
      }
    }
    let rr_slider = $('.price-right');
    let rr_val = rr_slider.val();
    let rr_width = rr_slider.width() - 15;
    let rr_min = rr_slider.attr('min');
    let rr_max = rr_slider.attr('max');
    let rr_percent = (rr_val - rr_min) / (rr_max - rr_min);
    let rr_offset = -3;
    let rr_newPosition = rr_width * rr_percent + rr_offset;
    //$('.r_range_position').css('left',rr_newPosition);
  };
  lowerSlider.oninput = function() {
    lowerVal = parseInt(lowerSlider.value);
    upperVal = parseInt(upperSlider.value);
    $('.prevtsetval').val(lowerVal);
    $('.nextsetval').val(upperVal);
    if (lowerVal > upperVal - 4) {
      upperSlider.value = lowerVal + 4;
      if (upperVal == upperSlider.max) {
         lowerSlider.value = parseInt(upperSlider.max) - 4;
      }
    }
    let rl_slider = $('.price-left');
    let rl_val = rl_slider.val();
    let rl_width = rl_slider.width() - 15;
    let rl_min = rl_slider.attr('min');
    let rl_max = rl_slider.attr('max');
    let rl_percent = (rl_val - rl_min) / (rl_max - rl_min);
    let rl_offset = -3;
    let rl_newPosition = rl_width * rl_percent + rl_offset;
    //$('.l_range_position').css('left',rl_newPosition);
  }; 
  $('.prevtsetval').on('change, keyup',function (e) {
    $('.price-left').val($(this).val());
    rangePrice();
  });
  $('.nextsetval').on('change, keyup',function (e) {
    $('.price-right').val($(this).val());
    rangePrice();
  });
}
if (document.querySelector(".rangecls")) {
  rangePrice();
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
$(document).on('click','.filter-button',function(e){
  e.preventDefault();
  $('body').toggleClass('filter-open');
});
// Sticky filter bar sits right under the sticky header group, whose height varies (announcement, app blocks)
const headerGroup = document.querySelector('.header_group');
if (headerGroup && 'ResizeObserver' in window) {
  new ResizeObserver(() => {
    document.documentElement.style.setProperty('--header-group-height', `${headerGroup.offsetHeight}px`);
  }).observe(headerGroup);
}
$(document).on('click','.facet-list h4,.filter-sort h4',function(e){
  e.preventDefault();
  $(this).toggleClass('active');
  $(this).next('.filterbox').slideToggle();
});
if($(window).width() < 576){
  if($('.coll-navlist li').length > 0){
    const getPo = $(".coll-navlist li a.active").offset().left;
    $(".coll-navlist").scrollLeft(getPo)
  }
}
function fnBrowserDetect(){
  let userAgent = navigator.userAgent;
  let browserName;
  if(userAgent.match(/chrome|chromium|crios/i)){
    browserName = "chrome";
  }else if(userAgent.match(/firefox|fxios/i)){
    browserName = "firefox";
  }  else if(userAgent.match(/safari/i)){
    browserName = "safari";
  }else if(userAgent.match(/opr\//i)){
    browserName = "opera";
  } else if(userAgent.match(/edg/i)){
    browserName = "edge";
  }else{
    browserName="no-browser";
  }
  document.getElementById('MainContent').classList.add(browserName);
}
fnBrowserDetect()